<script setup lang="ts">
import { OrganismProductsProps } from "./OrganismProducts.props"

defineProps<OrganismProductsProps>()
</script>

<template>
  <div
    class="wrapper_organism-products carousel-container-overflowed pb-10 pt-6"
  >
    <p
      v-if="title"
      class="elephant-bold md:mammoth-bold mb-5 uppercase md:col-span-full"
    >
      {{ title }}
    </p>

    <div class="mb-6 md:col-span-full">
      <UtilsWrapperImage
        v-if="image"
        v-bind="image"
        :key="image.image.url"
        class="
          wrapper-image-fixed-112
          md:wrapper-image-fixed-340
          lg:wrapper-image-fixed-488
          wrapper-image-full-container-centered
          overflow-hidden
          rounded-lg
        "
        sizes="100vw lg:100vw"
      />
    </div>

    <div class="grid-container">
      <ProductTileOverallResults
        v-for="product in products"
        v-bind="product"
        class="col-span-full w-full md:col-span-4"
        listing-layout
      />
    </div>
  </div>
</template>
